// @ts-check

/** @type { Partial<CabD.A.ContainerConfigs.ContainerConfig> } */
export const TwooDoorUpperFlipUpr = {
  layout: 'DEPTH',
  height: 36,
  depth: 13,
  width: 36,
  name: '2 Door Upper Flip Upr',
  isTopLevel: true,
  mountTypes: [
    'wall'
  ],
  constrName: 'WallCabinet',
  children: [
    {
      name: 'UpperCarcassAssembly',
      layout: 'WIDTH',
      children: [
        {
          name: 'UpperLeftSide',
          type: 'Panel',
          width: 0.5
        },
        {
          name: 'UpperCarcassAssembly--InteriorAssembly',
          children: [
            {
              name: 'UpperBottom',
              height: 0.5,
              type: 'Panel'
            },
            {
              name: 'UpperInteriorAssembly',
              layout: 'DEPTH',
              children: [
                {
                  name: 'UpperBack',
                  type: 'Panel',
                  depth: 0.5
                },
                {
                  name: 'UpperInterior',
                  children: [
                    {
                      name: 'Interior',
                      children: [
                        {},
                        {
                          height: 0.5,
                          type: 'Panel',
                          name: 'Shelf'
                        },
                        {},
                        {
                          height: 0.5,
                          type: 'Panel',
                          name: 'Shelf'
                        },
                        {}
                      ]
                    }
                  ]
                }
              ]
            },
            {
              name: 'UpperTop',
              type: 'Panel',
              height: 0.5
            }
          ]
        },
        {
          name: 'UpperRightSide',
          width: 0.5,
          type: 'Panel'
        }
      ]
    },
    {
      name: 'FrontExteriorAssembly',
      layout: 'WIDTH',
      depth: 0.5,
      children: [
        {
          name: 'LeftDoorOverlay',
          width: 0.25
        },
        {
          name: 'FrontAssembly',
          children: [
            {
              name: 'BottomReveal',
              height: 0.25
            },
            {
              handlePosition: {
                oX: {
                  type: 'center',
                  value: null
                },
                oY: {
                  type: 'toBottom',
                  value: 3
                },
                oZ: 'onSurface'
              },
              type: 'Door',
              name: 'Door--DoorPanel'
            },
            {
              name: 'Reveal',
              height: 0.25
            },
            {
              handlePosition: {
                oX: {
                  type: 'center',
                  value: null
                },
                oY: {
                  type: 'toBottom',
                  value: 3
                },
                oZ: 'onSurface'
              },
              type: 'Door',
              name: 'Door--DoorPanel'
            },
            {
              name: 'TopReveal',
              height: 0.25
            }
          ]
        },
        {
          name: 'RightDoorOverlay',
          width: 0.25
        }
      ]
    }
  ],
  countertopMaterialName: 'marblewhite005'
};
